module.exports = __webpack_public_path__ + "img/report2.64bff553.svg";